import axios from 'axios';
import { useFormik } from 'formik';

export default function Enquiry(){

    const initialValues = {
        name: '',
        phone: '',
        query: ''
    };

    const validate = (values) => {
        let errors = {};

        if (values.name.trim().length < 2){
            errors.name = "Please enter a valid name atleast 2 characters";
        }
        if (! values.name.match(/^[a-zA-Z ]+$/)){  //.match('[a-zA-Z ]+')
            errors.name = "Name should contain alphanumeric characters only";
        }

        if (values.phone.toString().trim().length !== 10){
            errors.phone = "Please enter a valid phone no. 10 numbers";
        }
        if (values.query.trim().length<5){
            errors.query = "Query should contain atlest 5 characters";
        }
        
        return errors;
    }

    const onSubmit = (values, {resetForm}) => {
        let data = {"name": values.name, "phone": values.phone, "query": values.query};
        // Commenting Shortcuts
        // console.log('data: ', data);// shift +command +L
        // console.log("🚀 ~ file: Enquiry.js:35 ~ onSubmit ~ data:", data) // alt/option + control + l
        // let url = "http://localhost:9999/save";
        let url = "https://js-enquery-application-backend.vercel.app/save";
        // let url = "https://js-enquery-application-backend-git-main-rishisetpal.vercel.app/save";
        
        axios.post(url, data)
        .then(response=>{
            console.log('response: ', response);

            alert("Record Mailed! Will get back to you!");
            resetForm();
        })
        .catch(err=>{console.log(err);});
    }

    const formik = useFormik({initialValues, validate, onSubmit});

    return(
        <>
        <center>
            <h1>Enquery Application </h1>
            {/* <div className='border'>
                <p> Enquery mail using nodemailer | </p>
                <p> Formik [State Management] for (initialState, validate, onSubmit) | </p>
                <p> Code Base on Github | </p>
                <p> UI Deployment on netlyfy | </p>
                <p> Backend Deployment on Vercel.</p>
            </div> */}

            <form className='border' onSubmit={formik.handleSubmit}>

                <p></p>
                <div className="container">
                    <label>Name:</label>
                    <input 
                        className='border' 
                        type="text" 
                        name="name" 
                        placeholder='Enter your Name' 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur} 
                        value={formik.values.name}/> 
                    <br />
                </div>
                {formik.touched.name && formik.errors.name 
                    ?   <div className='err'>
                            {formik.errors.name}
                        </div>
                    : null
                }

                <div className="container">
                    <label>Phone:</label>
                    <input className='border' type="number" name="phone" placeholder='Enter your Phoneno:' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.phone}/> <br />
                </div>
                {formik.touched.phone && formik.errors.phone 
                    ?   <div className='err'>
                            {formik.errors.phone}
                        </div>
                    : null
                }

                <div className="container">
                    <label >Query:</label>
                    <textarea className='border' type="text" name="query" placeholder='Enter your Query:' rows={5} cols={18} onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.query}></textarea> <br />
                </div>
                {formik.touched.query && formik.errors.query 
                    ?   <div className='err'>
                            {formik.errors.query}
                        </div>
                    : null
                }

                <input className='border' style={{backgroundColor: 'black'}} type="submit" value={"Send Mail"} />
                
            </form>
        </center>
        </>
    );
}
